import { useState } from "react";

export default function App() {
  const [downloaddata, setDownloadData] = useState("");
  const navigateDowmnloadDocument = () => {
    download();
  };
  const download = async () => {

    await fetch(
      "https://83r15wflik.execute-api.ap-south-1.amazonaws.com/v3/digilocker/download",
      {
        method: "POST",
        body: JSON.stringify({
          accessRequestId: "3cc1927d-224c-41e3-983d-1a835c6b94b",
          file: [
            {
              uri: "in.gov.uidai-ADHAR-90b5f642430fc3321954ff705a2821e3",
              doctype: "ADHAR",
              parsed: true,
              pdfB64: true,
              xml: true,
              pdf: true,
            },
            {
              uri: "in.gov.pan-PANCR-AVWPH6294G",
              doctype: "PANCR",
              pdfB64: true,
              parsed: true,
              xml: true,
            },
            {
              uri: "in.gov.msme-UDCER-UDYAMUP010016341-9967447251",
              pdfB64: true,
              parsed: true,
              docType: "UDCER",
              xml: true,
            },
          ],
        }),
        headers: {
          "x-api-key": "AEc3A0jrPy8yQcuUZvT909mu8ZV933Yd5dijiix8",
          key: "79993401FEAD58EE8B4965C62CCE60E4",
        },
      }
    )
      .then((res) => res.json())

      .then((data) => {
        setDownloadData(data);
        console.log(data, "DOWNLOAD");
        // down(data)
alert("Donwload")
   
  
       
        
      });
  };
  return (
    <>
    <div className="App">
      <h1>Donwload Component</h1>
      <button
              onClick={navigateDowmnloadDocument}
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: " #e54d19",
              }}
            >
              {" "}
              Download Documents
            </button>    </div>
    <div className="downloaddiv">
            {downloaddata?.data?.data?.result?.map(() => {
           alert('h')
            return        <ul> <li >{downloaddata?.data?.result?.documentUri}</li>;
            
                      </ul>
          
          },
          // console.log(downloaddata.parsedFile.data.issuedTo.photo.content)
          
          )}
        </div>
        <div> 

          {downloaddata.message}
          {downloaddata.status}
          </div>
    </>
  );
}
